import Model from './BaseModel'

export default class State extends Model {
    resourceName() {
        return 'states'
    }

    fields() {
        return ['id', 'name', 'uf']
    }
}
